// extracted by mini-css-extract-plugin
export var deliveryRow = "_q3-a";
export var fixedHeight = "_q3-4";
export var freightLogo = "_q3-9";
export var fullWidth = "_q3-3";
export var priceColumn = "_q3-5";
export var radioSelected = "_q3-7";
export var radioUnselected = "_q3-6";
export var selectedOption = "_q3-2";
export var selectedOptionContainer = "_q3-1";
export var selection = "_q3-0";
export var tallSkeletonText = "_q3-8";